/** Helper chunk to get the PCF soft shadow generated by all the {@link core/lights/DirectionalLight.DirectionalLight | DirectionalLight}, {@link core/lights/PointLight.PointLight | PointLight} and {@link core/lights/SpotLight.SpotLight | SpotLight}. */
export const getPCFShadows: string = /* wgsl */ `
  let pointShadows = getPCFPointShadows(worldPosition);
  let directionalShadows = getPCFDirectionalShadows(worldPosition);
  let spotShadows = getPCFSpotShadows(worldPosition);
`
